// extracted by mini-css-extract-plugin
module.exports = {"bannerTextWidth":"reviewsPage_bannerTextWidth__zMuKZ","pusherDiv":"reviewsPage_pusherDiv__3rRbf"};